import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import {
  IColumnSortEvent,
  SortDirection,
} from '../_interfaces/i-column-sort-event';

const rotate: { [key: string]: SortDirection } = {
  asc: 'desc',
  desc: '',
  '': 'asc',
};

@Directive({
  selector: 'th[sortable]',
})
export class ColumnSortingDirective {
  @Input() sortable: any = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<IColumnSortEvent>();

  @HostBinding('class.asc') get asc() {
    return this.direction == 'asc';
  }

  @HostBinding('class.desc') get desc() {
    return this.direction == 'desc';
  }

  @HostListener('click') rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
